// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a69b2680","503":"03f06ac8","644":"785db8ba","667":"ded20ff4","808":"75e9ed13"}[chunkId] + ".chunk.js";
};